import React, { useState } from 'react';
import { Spinner, Stack, Text } from '@fluentui/react';
import { PDFViewer } from '@react-pdf/renderer';
import { useQuery } from '@apollo/client';
import { GET_PURCHASE_ORDER_BY_ID, IPurchaseOrder } from '../../../utils';
import { toastError } from '../../../utils/toast';
import PurchaseOrderDownloadTemplate from './PurchaseOrderDownloadTemplate';

type Props = {
  purchaseOrderId: number;
  height?: number | string;
  fillContainer?: boolean;
};

const frameStyle: React.CSSProperties = {
  border: '1px solid #edebe9',
  borderRadius: 4,
  overflow: 'hidden',
  background: '#fff',
};

const PurchaseOrderPdfInline = ({
  purchaseOrderId,
  height = 360,
  fillContainer = false,
}: Props) => {
  const [purchaseOrder, setPurchaseOrder] = useState<IPurchaseOrder | undefined>();

  const { loading, error } = useQuery(GET_PURCHASE_ORDER_BY_ID, {
    variables: { where: { id: purchaseOrderId } },
    fetchPolicy: 'no-cache',
    onError: err => toastError(err.message),
    onCompleted: data => setPurchaseOrder(data.findOnePurchaseOrder),
  });

  const wrapStyle: React.CSSProperties = fillContainer
    ? {
 position: 'relative', flex: 1, minHeight: 400, width: '100%',
}
    : { height, width: '100%' };

  const innerStyle: React.CSSProperties = fillContainer
    ? { ...frameStyle, position: 'absolute', inset: 0 }
    : { ...frameStyle, height: '100%' };

  if (loading) {
    return (
      <div style={wrapStyle}>
        <Stack
          horizontalAlign='center'
          verticalAlign='center'
          styles={{ root: fillContainer ? { position: 'absolute', inset: 0 } : { height } }}
        >
          <Spinner label='Bestelbon PDF laden...' />
        </Stack>
      </div>
    );
  }

  if (error || !purchaseOrder) {
    return (
      <div style={wrapStyle}>
        <Text style={{ color: '#a4262c', fontSize: 12, padding: 12 }}>
          Bestelbon PDF kon niet geladen worden.
        </Text>
      </div>
    );
  }

  return (
    <div style={wrapStyle}>
      <div style={innerStyle}>
        <PDFViewer width='100%' height='100%'>
          <PurchaseOrderDownloadTemplate purchaseOrder={purchaseOrder} />
        </PDFViewer>
      </div>
    </div>
  );
};

export default PurchaseOrderPdfInline;
